module.exports = __webpack_public_path__ + "static/media/research-1-screenshot.4a5506ca.png";